import { render, staticRenderFns } from "./ReferralPurchaseTable.vue?vue&type=template&id=118247c7&scoped=true"
import script from "./ReferralPurchaseTable.vue?vue&type=script&lang=js"
export * from "./ReferralPurchaseTable.vue?vue&type=script&lang=js"
import style0 from "./ReferralPurchaseTable.vue?vue&type=style&index=0&id=118247c7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118247c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('118247c7')) {
      api.createRecord('118247c7', component.options)
    } else {
      api.reload('118247c7', component.options)
    }
    module.hot.accept("./ReferralPurchaseTable.vue?vue&type=template&id=118247c7&scoped=true", function () {
      api.rerender('118247c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/referral_purchase/ReferralPurchaseTable.vue"
export default component.exports